import _ from "lodash";

export type Brand = "tokyotreat" | "sakuraco" | "yumetwins" | "nomakenolife";

export const colorsByBrand: Record<Brand, string> = {
  tokyotreat: "orange",
  sakuraco: "yellow",
  yumetwins: "violet",
  nomakenolife: "pink",
};

export const brands: Brand[] = [
  "tokyotreat",
  "sakuraco",
  "yumetwins",
  "nomakenolife",
];

export const selectBrands = brands.map((brand) => {
  return { value: brand, label: brand };
});
